<template>
  <form action="false" @submit.prevent="handleSubmitAssign">
    <div class="modal_inputs">
      <Text bold class="mb-3" text="Jets"></Text>
      <FormKit
        :classes="{
          containerActive: 'ring-3 ring-hqPurple',
          optionSelected: 'bg-hqPurple text-white',
          optionSelectedPointed: 'bg-hqPurple text-white',
        }"
        v-model="formData.jet.printer_id"
        placeholder="Select a Printer"
        :options="lasersOptions"
        type="select"
      />
      <FormKit
        v-model="formData.jet.active_printers"
        @input="formData.jet.active_printers = Number(formData.jet.active_printers)"
        input-class="h-10 w-56"
        outer-class="m-0"
        placeholder="Active Printers"
        type="number"
        min="1"
      />
      <Text bold class="mb-3" text="Drones"></Text>
      <FormKit
        :classes="{
          containerActive: 'ring-3 ring-hqPurple',
          optionSelected: 'bg-hqPurple text-white',
          optionSelectedPointed: 'bg-hqPurple text-white',
        }"
        v-model="formData.drone.printer_id"
        placeholder="Select a Printer"
        :options="lasersOptions"
        type="select"
      />
      <FormKit
        v-model="formData.drone.active_printers"
        @input="formData.drone.active_printers = Number(formData.drone.active_printers)"
        input-class="h-10 w-56"
        outer-class="m-0"
        placeholder="Active Printers"
        type="number"
        min="1"
      />
      <Text bold class="mb-3" text="Mini Rockets"></Text>
      <FormKit
        :classes="{
          containerActive: 'ring-3 ring-hqPurple',
          optionSelected: 'bg-hqPurple text-white',
          optionSelectedPointed: 'bg-hqPurple text-white',
        }"
        v-model="formData.mRocket.printer_id"
        placeholder="Select a Printer"
        :options="lasersOptions"
        type="select"
      />
      <FormKit
        v-model="formData.mRocket.active_printers"
        @input="formData.mRocket.active_printers = Number(formData.mRocket.active_printers)"
        input-class="h-10 w-56"
        outer-class="m-0"
        placeholder="Active Printers"
        type="number"
        min="1"
      />
      <Text bold class="mb-3" text="Rocket"></Text>
      <FormKit
        :classes="{
          containerActive: 'ring-3 ring-hqPurple',
          optionSelected: 'bg-hqPurple text-white',
          optionSelectedPointed: 'bg-hqPurple text-white',
        }"
        v-model="formData.rocket.printer_id"
        placeholder="Select a Printer"
        :options="lasersOptions"
        type="select"
      />
      <FormKit
        v-model="formData.rocket.active_printers"
        @input="formData.rocket.active_printers = Number(formData.rocket.active_printers)"
        input-class="h-10 w-56"
        outer-class="m-0"
        placeholder="Active Printers"
        type="number"
        min="1"
      />
    </div>
    <div class="modal_actions">
      <Button secondaryButton text="Cancel" @click="handleCancel" />
      <Button text="Update Settings" type="submit" />
    </div>
  </form>
</template>
<script setup>
import Button from "@/components/UI/Form/Button/Button.vue";
import { useProductionEstimateSettings } from "@/components/UI/Modal/Bodies/ProductionEstimateSettings/ProductionEstimateSettings.hook";
import Text from "@/components/UI/Typography/Text.vue";

const { formData, lasersOptions, handleSubmitAssign, handleCancel } =
  useProductionEstimateSettings();
</script>
